// LicensesManagement.js

import React, { useEffect, useState } from 'react';

import LicenseInfo from '../components/licenses/LicenseInfo'; // Import LicenseInfo component
import LicensesList from '../components/licenses/LicensesList';
import { Add } from '@mui/icons-material';
import { ButtonGroup, IconButton, Typography } from '@mui/material';

import './LicensesManagement.css';
import '../../b2b-common/B2BButtonGroup.css'
import { withAutoFocus } from '../../b2b-common/helpers';

const LicensesManagement = ({ licenses, onUpdatedLicenses }) => {
    const [selectedLicense, setSelectedLicense] = useState(null);
    const [isNewLicense, setIsNewLicense] = useState(false);
    const [unavailableDateRanges, setUnavailableDateRanges] = useState([]);
    const AutoFocusedLicenseInfo = withAutoFocus(LicenseInfo);

    useEffect(() => {
        setSelectedLicense(selectedLicense);
        // Get all date ranges from licenses except the selected one
        const newUnavailableDateRanges = selectedLicense
            ? licenses
                .filter((license) => {
                    const isExcluded = license.licenseId !== selectedLicense.licenseId;
                    return isExcluded;
                })
                .map((license) => {
                    const startDate = new Date(license.startDate);
                    const endDate = new Date(license.endDate);
                    return [startDate, endDate];
                })
            : [];
        setUnavailableDateRanges(newUnavailableDateRanges);
    }, [selectedLicense]);

    const handleViewDetails = (license, newLicense = false) => {
        setSelectedLicense(license);
        setIsNewLicense(newLicense);
    };

    const handleHideDetails = () => {
        setSelectedLicense(null);
    };

    const handleLicenseUpdate = (updatedLicense) => {
        const existingLicense = licenses.find((license) => license.licenseId === updatedLicense.licenseId);
        if (existingLicense) {
            const updatedLicenses = licenses.map((license) => {
                if (license.licenseId === updatedLicense.licenseId) {
                    return updatedLicense;
                }
                return license;
            });
            onUpdatedLicenses(updatedLicenses);
        } else {
            const updatedLicenses = [...licenses, updatedLicense];
            onUpdatedLicenses(updatedLicenses);
        }
    }

    const handleLicenseRemove = (removedLicense) => {
        const updatedLicenses = licenses.filter((license) => license.licenseId !== removedLicense.licenseId);
        onUpdatedLicenses(updatedLicenses);
    }


    const licenseButtons = [
        <IconButton
            key="new"
            onClick={() => handleViewDetails(getNewLicenseObject(), true)}
        >
            <Add />
            <Typography variant="body2">New License</Typography>
        </IconButton>,

    ];

    return (
        <div className='licenses-management'>
            <LicensesList
                licenses={licenses}
                onSelectLicense={handleViewDetails}
            />
            <ButtonGroup size="small" aria-label="small button group" className="b2b-default-button-group">
                {licenseButtons}
            </ButtonGroup>
            {selectedLicense && (
                <AutoFocusedLicenseInfo
                    id="license-info"
                    initialLicense={selectedLicense}
                    isNewLicense={isNewLicense}
                    onClose={handleHideDetails}
                    unavailableDateRanges={unavailableDateRanges}
                    onLicenseUpdate={handleLicenseUpdate}
                    onLicenseRemove={handleLicenseRemove}
                />
            )}
        </div>
    );
};

const getNewLicenseObject = () => {
    return {
        licenseCode: "PENDING",
        startDate: null,
        endDate: null,
        enabled: true,
        products: [],
    }
}

export default LicensesManagement;
